import './CompanyCards.css';
import natureMadeLogo from '../../images/company-logos/nature-made.jpg';
import rodeLogo from '../../images/company-logos/rode.jpg';
import logitechLogo from '../../images/company-logos/logitech.webp';
import steveMaddenLogo from '../../images/company-logos/steve-madden.jpg';
import bigBlanketLogo from '../../images/company-logos/big-blanket.jpg';

const CompanyCards = () => {

  return (
    <div className='company-cards-container'>
      <div className='company-cards-grid'>
        {/* <div className='company-card'>
          <img src={natureMadeLogo} alt="Nature Made" className="company-logo" />
        </div> */}
        <div className='company-card'>
          <img src={rodeLogo} alt="Rode" className="company-logo" />
        </div>
        <div className='company-card'>
          <img src={logitechLogo} alt="Logitech" className="company-logo" />
        </div>
        <div className='company-card'>
          <img src={steveMaddenLogo} alt="Steve Madden" className="company-logo" />
        </div>
        <div className='company-card'>
          <img src={bigBlanketLogo} alt="Big Blanket" className="company-logo" />
        </div>
      </div>
    </div>
  );
}

export default CompanyCards;
